function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M2.78 2.5h9.73A6.48 6.48 0 0119 9v22.7a4.87 4.87 0 00-4.87-4.86H2.78V2.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  d: "M35.22 2.5h-9.73A6.48 6.48 0 0019 9v22.7a4.87 4.87 0 014.87-4.86h11.35V2.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M29.24.5v11"
}));

function SvgTutorials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 34"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOCAzNCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIpIj4KICAgIDxwYXRoIHN0cm9rZT0iIzMzMyIgZD0iTTAuNzgsMi40OTk5OTIyMiBMMTAuNTEsMi40OTk5OTIyMiBDMTIuMjMzODA1OSwyLjQ5NzMzMTU5IDEzLjg4NzYzMTIsMy4xODE2MTQ3MSAxNS4xMDU2MDg4LDQuNDAxNDY5MDIgQzE2LjMyMzU4NjQsNS42MjEzMjMzMyAxNy4wMDUzMjI1LDcuMjc2MjAwMjMgMTcuMDAwMDMwOSw4Ljk5OTk5MjIyIEwxNy4wMDAwMzA5LDMxLjcgQzE2Ljk5NDQ4NTIsMjkuMDE0Mjc5MyAxNC44MTU3MjYzLDI2LjgzOTk5NDMgMTIuMTMsMjYuODQgTDAuNzgsMjYuODQgTDAuNzgsMi40OTk5OTIyMiBaIi8+CiAgICA8cGF0aCBzdHJva2U9IiMzMzMiIGQ9Ik0zMy4yMiwyLjQ5OTk5MjIyIEwyMy40OSwyLjQ5OTk5MjIyIEMyMS43NjYxOTQxLDIuNDk3MzMxNTkgMjAuMTEyMzY4OCwzLjE4MTYxNDcxIDE4Ljg5NDM5MTIsNC40MDE0NjkwMiBDMTcuNjc2NDEzNiw1LjYyMTMyMzMzIDE2Ljk5NDY3NzUsNy4yNzYyMDAyMyAxNi45OTk5NjkxLDguOTk5OTkyMjIgTDE2Ljk5OTk2OTEsMzEuNyBDMTcuMDA1NTE0OCwyOS4wMTQyNzkzIDE5LjE4NDI3MzcsMjYuODM5OTk0MyAyMS44NywyNi44NCBMMzMuMjIsMjYuODQgTDMzLjIyLDIuNDk5OTkyMjIgWiIvPgogICAgPGxpbmUgeDE9IjI3LjI0IiB4Mj0iMjcuMjQiIHkxPSIuNSIgeTI9IjExLjUiIHN0cm9rZT0iIzIzQzM4NiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgTutorials as ReactComponent };